import React, { useEffect, useState, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import api from '../components/api';
import { dataTableRender, sleep } from '../components/functions'
//import { MDBDataTableV5 } from 'mdbreact';

import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { ExportToCsv } from 'export-to-csv';
import moment from 'moment'

import "@fortawesome/fontawesome-free/css/all.min.css";


const AdesaoInstitucional = () => {

    var [resultado, setResultado] = useState([])
    var [adesao_institucional_id, setAdesaoInstitucionalId] = useState()
    var [resultadoRede, setResultadoRede] = useState()
    var [adesao_institucional_id_ref, setAdesaoInstitucionalIdRef] = useState(0)

    const [loading, setLoading] = useState(false)

    
    const history = useHistory();


    /*
    async function geraExcel() {

        

        window.toastr.success('Aguarde, gerando XLSX...')

        await api.get('geraExcelAdesao').then((result) => {

            if (result.data.alerta == 'ok') {

                sleep(1000).then(() => {

                    //window.open(`http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`)
                    //window.location.href = `http://172.16.1.253:3600/${result.data.arquivo}`
                    window.location.href = `${process.env.REACT_APP_API}/${result.data.arquivo}`


                })
               
            }

        }).catch((err) => {

            console.log(err.response)

        })

    }
    */


    const geraExcel = async () => {

      window.toastr.info("Aguarde...");

      try {

      const response = await api.get(`geraExcelAdesao`, {
          responseType: "blob",
          validateStatus: (status) => true // para não cair direto no catch
      });

      if (response.status !== 200) {
          // ler como texto para ver o erro real
          const errorText = await response.data.text();
          console.error("Erro backend:", errorText);
          window.toastr.error("Erro ao exportar: " + errorText);
          return;
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "adesoesInstitucionais.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      window.toastr.success("Download concluído!");
      } catch (err) {
      console.error(err);
      window.toastr.error("Falha ao baixar arquivo");
      }
  };





    async function carregaRede() {

        await api.get(`adesaoInstitucionalRede`).then((result) => {

            setResultadoRede(result.data.map((rs) =>

                <option value={rs.adesao_institucional_id} key={rs.adesao_institucional_id}>{rs.razao_social}</option>
            
            ))

        })

    }


    async function verificaPermissao() {


        if (sessionStorage.getItem('permAdesoes') != 'true') {

            history.push('/')

        }


    }

    useEffect(() => {

        verificaPermissao()
        carregaRede()

    }, [])


    
    useEffect(() => {


        if (adesao_institucional_id) {

            history.push(`/AdesaoInstitucional/${adesao_institucional_id}`)

        }
        

    }, [adesao_institucional_id])

    
    async function adesaoInstitucionalLista(adesao_institucional_id_ref) {

        if (adesao_institucional_id_ref == null) {
            adesao_institucional_id_ref = 0
        }

        setLoading(true)

        try {

            const result = await api.get(
                `adesaoInstitucionalListaTodos/${adesao_institucional_id_ref}`
            )

            setResultado(
                result.data.map((rs) => {

                    return {

                        ad_new: rs.ad_new_format,

                        nome_fantasia:
                            rs.nome_fantasia,

                        cnpj:
                            rs.cnpj,

                        ultimoAnoCompras:
                            rs.ultimoAnoCompras,

                        ultimoAnoEnergia:
                            rs.ultimoAnoEnergia,

                        ultimoAnoClima:
                            rs.ultimoAnoClima,

                        ultimoAnoResiduos:
                            rs.ultimoAnoResiduos,

                        RtZ:
                            rs.RtZ,

                        categoria_adesao:
                            rs.categoria_adesao,

                        adesao_institucional_id:
                            rs.adesao_institucional_id,

                        ultimoRecad:
                            rs.ultimoRecad,

                        clickEvent: () =>
                            history.push(
                                `AdesaoInstitucional/${rs.adesao_institucional_id}`
                            )

                    }

                })
            )

        } catch (err) {

            console.log(err.response)

            window.toastr.error(
                'Erro ao carregar as instituições'
            )

        } finally {

            setLoading(false)

        }

    }



    useEffect(() => {

        adesaoInstitucionalLista()


    }, [])



    const columns = useMemo(
        () => [
        
          {
            accessorKey: 'ad_new',
            header: 'Registro',
            accessorFn: (row) => {
              // Divide a data da hora
              const [datePart, timePart] = row.ad_new.split(' ');
              const [year, month, day] = datePart.split('-');
          
              // Junta no formato ISO reconhecido pelo JavaScript
              return new Date(`${year}-${month}-${day}T${timePart}`);
            },
            Cell: ({ cell }) => {
              const date = cell.getValue();
              return date instanceof Date && !isNaN(date)
                ? moment(date).format('DD/MM/YYYY HH:mm:ss')
                : '';
            },
            sortingFn: 'datetime',
            muiTableHeadCellProps: {
              align: 'center',
            },
            muiTableBodyCellProps: {
              align: 'center',
            },
          },
          {
            accessorKey: 'nome_fantasia',
            header: 'Nome Fantasia',
          },
          {
            accessorKey: 'cnpj',
            header: 'CNPJ',
          },
          {
            accessorKey: 'ultimoRecad',
            header: 'Ano Últ. Recad.',
          },
          
          {
            accessorKey: 'categoria_adesao', //access nested data with dot notation
            header: 'Gestor de rede',
            muiTableHeadCellProps: {
                align: 'center',
              },
            muiTableBodyCellProps: {
                align: 'center',
              },
            Cell: ({ renderedCellValue, row }) => (
                
                    //renderedCellValue == 'G' ? 'Sim' : ''
                    <span className={`label label-success`} style={{ display: renderedCellValue == 'G' ? 'block' : 'none'}} >Sim</span>

            )        
            ,
           
          },
         
          {
            accessorKey: 'ultimoAnoClima', //normal accessorKey
            header: 'Clima',
            muiTableHeadCellProps: {
                align: 'center',
              },
            muiTableBodyCellProps: {
                align: 'center',
              },
          },
          {
            accessorKey: 'ultimoAnoEnergia',
            header: 'Energia',
          },
          {
            accessorKey: 'ultimoAnoResiduos',
            header: 'Resíduos',
          },
          {
            accessorKey: 'ultimoAnoCompras',
            header: 'Compras',
          },
          {
            accessorKey: 'RtZ',
            header: 'RtZ',
          },

        ],
        [],
      );

    


    const csvOptions = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        useBom: true,
        useKeysAsHeaders: false,
        headers: columns.map((c) => c.header),
      };
      
      const csvExporter = new ExportToCsv(csvOptions);
  
      const handleExportRows = () => {
        csvExporter.generateCsv(resultado);
      };
    
  

      const exportaUsuariosHospitais = () => {

        api.get('usuarioExtraiExcel').then((result) => {

            console.log(result.data)

            if (result.data.alerta == 'ok') {

                sleep(1000).then(() => {

                    //window.open(`http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`)
                    //window.location.href = `http://172.16.1.253:3600/${result.data.arquivo}`
                    window.location.href = `${process.env.REACT_APP_API}/${result.data.arquivo}`


                })
            
            }


        }).catch((err) => {

            console.log(err.response)

        })



      }




    return (

        <div>
             <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-users'></i>
                </div>
                <div class='header-title'>
                    <h1>Ades&atilde;o Institucional</h1>
                    <small>Administração</small>
                    
                </div>
            </div>


            <div className="row">



                <div class="col-md-12">

                    <br/>
                    
                    <button type="button" class="btn btn-success" onClick={() => geraExcel()}>Exportar XLS</button>&nbsp;
                    <button type="button" class="btn btn-info" onClick={handleExportRows} style={{ display: 'none'}}>Exportar CSV</button>
                    <button type="button" class="btn btn-primary" onClick={() => exportaUsuariosHospitais() } >Exportar Usuários Hospitais</button>
                    <br/><br/>
                    
                    
                </div>



                <div className="col-md-12">
                    <div className="form-group">
                        
                        <select style={{ backgroundColor: '#f0f9fa'}} className="form-control" onChange={event => {adesaoInstitucionalLista(event.target.value);setAdesaoInstitucionalIdRef(event.target.value)}} value={adesao_institucional_id_ref} >
                            <option value="0">[Rede ou Sistema de Saúde]</option>
                            {resultadoRede}
                        </select>  
                        
                    </div>
                </div>


            
                <div className="col-sm-12" >
                    


                            <MaterialReactTable
                                columns={columns}
                                data={resultado}
                                localization={MRT_Localization_PT_BR}

                                state={{
                                    isLoading: loading,
                                    showProgressBars: loading
                                }}

                                initialState={{
                                    density: 'compact',

                                    pagination: {
                                        pageSize: 15,
                                        pageIndex: 0,
                                    },

                                    sorting: [
                                        {
                                            id: 'ad_new',
                                            desc: true,
                                        },
                                    ],
                                }}

                                muiTableHeadCellProps={{
                                    sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                    },
                                }}

                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                    },
                                }}

                                muiTableBodyRowProps={({ row }) => ({
                                    onClick: () => {

                                        history.push(
                                            `AdesaoInstitucional/${row.original.adesao_institucional_id}`
                                        )

                                    },

                                    sx: {
                                        cursor: 'pointer',
                                    },
                                })}
                            />
                            




                    </div>

                    
                

                

                
            </div>



        
            

        </div>

    )

}

export default AdesaoInstitucional